var _path, _path2, _path3, _path4, _path5, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDuoMenuCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    transform: "rotate(0 0 0)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 5.99921C3.75 7.24141 4.757 8.24841 5.99921 8.24841C7.24141 8.24841 8.24841 7.24141 8.24841 5.99921C8.24841 4.757 7.24141 3.75 5.99921 3.75C4.757 3.75 3.75 4.757 3.75 5.99921Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9996 14.2494C10.7574 14.2494 9.75037 13.2424 9.75037 12.0002C9.75037 10.758 10.7574 9.75098 11.9996 9.75098C13.2418 9.75098 14.2488 10.758 14.2488 12.0002C14.2488 13.2424 13.2418 14.2494 11.9996 14.2494Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7507 5.99921C15.7507 7.24141 16.7577 8.24841 17.9999 8.24841C19.2421 8.24841 20.2491 7.24141 20.2491 5.99921C20.2491 4.757 19.2421 3.75 17.9999 3.75C16.7577 3.75 15.7507 4.757 15.7507 5.99921Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 18.0002C3.75 19.2424 4.757 20.2494 5.99921 20.2494C7.24141 20.2494 8.24841 19.2424 8.24841 18.0002C8.24841 16.758 7.24141 15.751 5.99921 15.751C4.757 15.751 3.75 16.758 3.75 18.0002Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7507 18.0002C15.7507 19.2424 16.7577 20.2494 17.9999 20.2494C19.2421 20.2494 20.2491 19.2424 20.2491 18.0002C20.2491 16.758 19.2421 15.751 17.9999 15.751C16.7577 15.751 15.7507 16.758 15.7507 18.0002Z",
    fill: "currentColor"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.75 12.0002C3.75 13.2424 4.757 14.2494 5.99921 14.2494C7.24141 14.2494 8.24841 13.2424 8.24841 12.0002C8.24841 10.758 7.24141 9.75098 5.99921 9.75098C4.757 9.75098 3.75 10.758 3.75 12.0002Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9999 14.2494C16.7577 14.2494 15.7507 13.2424 15.7507 12.0002C15.7507 10.758 16.7577 9.75098 17.9999 9.75098C19.2421 9.75098 20.2491 10.758 20.2491 12.0002C20.2491 13.2424 19.2421 14.2494 17.9999 14.2494Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.75037 5.99921C9.75037 7.24141 10.7574 8.24841 11.9996 8.24841C13.2418 8.24841 14.2488 7.24141 14.2488 5.99921C14.2488 4.757 13.2418 3.75 11.9996 3.75C10.7574 3.75 9.75037 4.757 9.75037 5.99921Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.75037 18.0002C9.75037 19.2424 10.7574 20.2494 11.9996 20.2494C13.2418 20.2494 14.2488 19.2424 14.2488 18.0002C14.2488 16.758 13.2418 15.751 11.9996 15.751C10.7574 15.751 9.75037 16.758 9.75037 18.0002Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuoMenuCircle);
export default __webpack_public_path__ + "static/media/DuoMenuCircle.1da0c515c79f9215b32bffe580949346.svg";
export { ForwardRef as ReactComponent };